import { render, staticRenderFns } from "./invitation_received.vue?vue&type=template&id=dd8b3154&scoped=true&"
import script from "./invitation_received.vue?vue&type=script&lang=ts&"
export * from "./invitation_received.vue?vue&type=script&lang=ts&"
import style0 from "./invitation_received.vue?vue&type=style&index=0&id=dd8b3154&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8b3154",
  null
  
)

export default component.exports